import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
} from '@mui/material';
import React from 'react';
import { changePasswordApi } from '../../../utils/api';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { isEmpty } from 'lodash';
import validator from '../../../input-validation.service';
import Switch from '../../../components/Switch';
import Button from '../../../components/Button';
import TextInput from '../../../components/TextInput';

const Security = () => {
  const [state, setState] = React.useState({
    showCurrentPassword: false,
    showNewPassword: false,
    newPassword: '',
    currentPassword: '',
    errorMessage: '',
  });

  const changePasswordHandler = useMutation(changePasswordApi, {
    onSuccess: async ({ data }) => {
      setState((prev) => {
        return { ...prev, showNewPassword: '', newPassword: '' };
      });
      toast.success('Password has been changed!');
    },
    onError: (error) => {
      console.log('error =====> ', error);
      return setState((prev) => {
        return { ...prev, errorMessage: error?.response?.data?.message || 'Something went wrong!' };
      });
    },
  });

  const handleChangePassword = (e) => {
    const { currentPassword, newPassword } = state;
    if (isEmpty(currentPassword) || isEmpty(newPassword)) {
      setState((prev) => {
        return { ...prev, errorMessage: 'Fill all the fields!' };
      });
      return;
    }

    if (currentPassword === newPassword) {
      setState((prev) => {
        return { ...prev, errorMessage: 'Current and new password cannot be same!' };
      });
      return;
    }

    if (validator.checkPasswordValidation(newPassword)) {
      setState((prev) => {
        return { ...prev, errorMessage: 'Password policy does not matched!' };
      });
      return;
    }

    changePasswordHandler.mutate({
      oldPassword: currentPassword,
      newPassword: newPassword,
    });
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <Box p={3} bgcolor="#fff" borderRadius={2}>
          <Typography variant="h6" gutterBottom>
            Change password
          </Typography>

          <TextInput
            label="Current password"
            fullWidth
            type={state.showCurrentPassword ? 'text' : 'password'}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  onClick={() =>
                    setState((prev) => {
                      return { ...prev, showCurrentPassword: !prev.showCurrentPassword };
                    })
                  }
                >
                  {!state.showCurrentPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </IconButton>
              </InputAdornment>
            }
            value={state.currentPassword}
            onChange={(e) =>
              setState((prev) => {
                return { ...prev, currentPassword: e.target.value };
              })
            }
          />

          <TextInput
            label="New password"
            fullWidth
            type={state.showNewPassword ? 'text' : 'password'}
            value={state.newPassword}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  onClick={() =>
                    setState((prev) => {
                      return { ...prev, showNewPassword: !prev.showNewPassword };
                    })
                  }
                >
                  {state.showNewPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
              </InputAdornment>
            }
            onChange={(e) =>
              setState((prev) => {
                return { ...prev, newPassword: e.target.value };
              })
            }
          />

          <Button fullWidth text="Change password" onClick={handleChangePassword} style={{ mt: 2 }} />

          <Typography variant="subtitle1" style={{ color: 'red', marginTop: '30px' }} textAlign="center">
            {state.errorMessage}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12} md={8}>
        <Box p={6} bgcolor="background.paper" borderRadius={2}>
          <Typography variant="h6" gutterBottom>
            Two-Factor Authentication
          </Typography>
          <Box display="flex" flexDirection="column" gap={2}>
            <FormControlLabel control={<Switch defaultChecked />} label="Text Message (SMS)" />
            <Typography variant="body2" color="textSecondary">
              Receive a one-time passcode via SMS each time you log in
            </Typography>
            <FormControlLabel control={<Switch />} label="Authenticator App (TOTP)" />
            <Typography variant="body2" color="textSecondary">
              Use an app to receive a temporary one-time passcode each time you log in.
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Security;
